import React, {useState} from 'react';
import ResponsiveImage from '@core/scripts/templates/ResponsiveImage.jsx';
import QuantitySelection from './cart-item/CartItemQuantitySelection.jsx';
import CartItemAttributes from './cart-item/CartItemAttributes.jsx';
import CartItemName from './cart-item/CartItemName.jsx';
import CartItemAvailability from './cart-item/CartItemAvailability.jsx';
import PricePerUnit from './cart-item/CartItemPricePerUnit.jsx';
import CartItemPrice from './cart-item/CartItemPrice.jsx';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import Messages from '@core/scripts/components/messages';
import Landmark from '@core/scripts/components/landmark-adapter';
import WishlistHeart from "@wishlist/components/heart";
import {IconButton} from '@bonprix/design-system';

export default function CartItem({
    item,
    items,
    texts,
    isCalculatingPrice = false,
    onChangeItemQuantity,
    onDeleteItem,
    isPickUpLocationSelectedDeliveryType,
    page,
    itemHeaderComponentSize
}) {
    const onDelete = () => {
        onDeleteItem(item, items);
        Landmark.sendClickLandmark('basket_entfernen');
    }
    const[onWishList, setOnWishList] = useState(false);

    const onEdit = (e) => {
        e.preventDefault();

        MessageBroker.publish(Messages.CHANGE_ITEM_LAYER_DATA, {
            notifiable: item.tempSold && !item.deliverable,
            origin: 'cartLayer', // TODO: Or lastcheck
            id: item.id,
            quantity: item.quantity,
            item: item,
        });

        Landmark.sendLandmark({
            landmark: 'layer_view',
            name: 'basket_change',
        });

        Landmark.sendClickLandmark('basket_change');
    };

    const onCartItemClick = () => Landmark.sendClickLandmark('back_to_adp');

    const imageOpacity = item.deliverable ? '1.0' : '0.5';

    return (
        <div className="flex mt-6">
            <a className="flex-none items-start pr-2.5" href={item.url} onClick={onCartItemClick}>
                <div className={'cart-item__image' + (!item.deliverable ? ' is-sold-out' : '')}>
                    <ResponsiveImage image={item.imageResource.image} alt={item.imageResource.alternativeText} style={{opacity: imageOpacity}} />
                    <div className="product-image__strike-through" />
                </div>
            </a>
            <div className="flex flex-col w-full">
                <div className="flex w-full">
                    <div className="flex-grow flex-col">
                        <CartItemName item={item} onNameClick={onCartItemClick} itemHeaderComponentSize={itemHeaderComponentSize} />
                        <CartItemAttributes item={item} texts={texts} page={page}/>
                        <CartItemAvailability
                            texts={texts}
                            showMessageNotDeliverableToPickUpLocation={
                                !item.deliverableToPickUpLocation && isPickUpLocationSelectedDeliveryType
                            }
                            isDeliverableToPickUpLocation={item.deliverableToPickUpLocation}
                            isPickUpLocationSelectedDeliveryType={isPickUpLocationSelectedDeliveryType}
                            deliverable={item.deliverable}
                            deliverableMessage={item.deliverableMessage}
                            tempSold={item.tempSold}
                            hints={item.hints}
                        />
                    </div>
                    <div className="flex flex-col gap-2.5 h-full">
                        <IconButton
                            icon="closer"
                            label={texts.checkout__delete_icon_screenreader_label}
                            variant="tertiary"
                            onClick={onDelete}
                            small

                        />
                        <IconButton
                            icon="edit"
                            label={texts.checkout__edit_icon_screenreader_label}
                            variant="tertiary"
                            onClick={onEdit}
                            small

                        />

                        <WishlistHeart
                            className="cart-item-details__wishlist-heart"
                            digistyleId={item.productId}
                            articleNumber={item.itemNumber}
                            promotion={item.promotion}
                            articlePrice={item.singlePriceValue}
                            masterStyleId={item.masterStyleId}
                            itemOptionName={item.itemOptionName}
                            shopId={item.shopId}
                            itemId={item.itemId}
                            itemOptionId={item.itemOptionId}
                            origin={page}
                            onWishList={onWishList}
                            setOnWishList={setOnWishList}/>
                    </div>
                </div>

                <div className="flex flex-wrap justify-between items-center l:flex-row l:justify-between">
                    <PricePerUnit price={item.singlePrice} texts={texts} />
                    <QuantitySelection
                        item={item}
                        items={items}
                        label={texts.wk_anzahl}
                        onChange={onChangeItemQuantity}
                        isCalculatingPrice={isCalculatingPrice}
                    />
                        <CartItemPrice
                            formerPrice={item.formerPrice}
                            summarizedPrice={item.summarizedPrice}
                            deliverable={item.deliverable}
                            reduction={item.reduction}
                            loading={isCalculatingPrice}
                        />
                </div>

                {/*
                    buttons inside form submit the form, problem in FF with preventDefault,
                    so only submit button should be a button
                */}

            </div>
        </div>
    );
}
